import { createContext, useContext } from 'react';
import { IInjectedServices } from './injected-services';

interface ServiceProviderProps {
	children: any;
	services: IInjectedServices;
}

const ServiceDependency = createContext({} as IInjectedServices);

export const useInjectedService = () => {
	return useContext(ServiceDependency);
};

export const ServicesProvider = ({ children, services }: ServiceProviderProps) => {
	return <ServiceDependency.Provider value={services}>{children}</ServiceDependency.Provider>;
};
